import React, { Component } from 'react';
import './Steps.css';
import API from '../services/api';

class Step1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepNumber: 1,
      fields: {
        sex: '',
        accountType: '',
        lookingFor: '',
        email: '',
        refCode: props.fields.refCode?props.fields.refCode:'',
      },
      errors: {
        email: '',
        refCode: '',
      },
    };
  }

  allFieldsFilled() {
    const emptyFields = Object.keys(this.state.fields).filter(field => {
      if (field !== 'refCode') {
        return this.state.fields[field].length === 0;
      } else {
        return false;
      }
    });
    return emptyFields.length === 0;
  }



  handleFieldChange(e, name) {
    let { errors, fields } = this.state;
    fields[name] = e.target.value;
    if(name === 'refCode') {
      errors.refCode = '';
    }
    if(name === 'email') {
      errors.email = '';
    }
    if(name === 'accountType') {
      fields.lookingFor = '';
    }
    this.setState({ fields, errors });
  }

  handleNext(e) {
    const { fields, errors } = this.state;
    e.preventDefault();
    (new API()).get('/users/validate-field', {field: 'email', value: fields.email})
      .then(response => {
        if(response.valid) {
          this.props.saveData(fields);
          this.props.proceed(this.state.stepNumber);
        } else {
          errors['email'] = 'E-mail is already in use. Choose different one.';
          this.setState({
          })
        }
      });
  }

  handleRefCodeBlur(e) {
    const { errors } = this.state;
    (new API()).post('/check-refCode', {refCode: e.target.value})
      .then(response => {
        if(!response.success) {
          errors['refCode'] = 'This promocode is invalid.';
          this.setState({
            errors,
          })
        }
      });
  }

  render() {
    const { fields, errors } = this.state;

    return (
      <div className={`Step Step-container ${(this.props.active)?'active':''}`}>
        <div className="Step-title">
          Basic Information
        </div>
        <ul className="steps">
          <li className="step-number done">1</li>
          <li className="step-number">2</li>
          <li className="step-number">3</li>
          <li className="step-number">4</li>
          <li className="step-number">5</li>
          <li className="step-number">6</li>
        </ul>
        <div className="field-container radio open">
          <div className="field-title">I am a:</div>
          <div className="row">
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="sexM" name="sex" value="M" />
            <label className="col" htmlFor="sexM">Man</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="sexF" name="sex" value="F" />
            <label className="col" htmlFor="sexF">Woman</label>
          </div>
        </div>
        <div className={`field-container radio ${(fields.sex.length > 0)?'open':'closed'}`}>
          <div className="field-title">I am a sugar:</div>
          <div className="row">
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="accountTypeParent" name="accountType" value="sugar_parent" />
            <label className="col" htmlFor="accountTypeParent">Sugar {(fields.sex === 'M')?'Daddy':'Mama'}</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="accountTypeBaby" name="accountType" value="sugar_baby" />
            <label className="col" htmlFor="accountTypeBaby">Sugar Baby</label>
          </div>
        </div>
        <div className={`field-container radio ${(fields.accountType.length > 0)?'open':'closed'}`}>
          <div className="field-title">Looking for:</div>
          <div className="row">
            <input onChange={e => this.handleFieldChange(e, e.target.name)} checked={fields.lookingFor.includes('_f')} type="radio" id="lookingForF" name="lookingFor" value={(fields.accountType === 'sugar_parent')?'sugar_baby_f':'sugar_parent_f'} />
            <label className="col" htmlFor="lookingForF">Women</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} checked={fields.lookingFor.includes('_m')} type="radio" id="lookingForM" name="lookingFor" value={(fields.accountType === 'sugar_parent')?'sugar_baby_m':'sugar_parent_m'} />
            <label className="col" htmlFor="lookingForM">Men</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} checked={fields.lookingFor.includes('_a')} type="radio" id="lookingForA" name="lookingFor" value={(fields.accountType === 'sugar_parent')?'sugar_baby_a':'sugar_parent_a'} />
            <label className="col" htmlFor="lookingForA">Both</label>
          </div>
        </div>
        <div className={`field-container text ${(fields.lookingFor.length > 0)?'open':'closed'}`}>
          <div className="field-title">Email Address:</div>
          <div className="row">
            <div className="col">
              <input onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="email" placeholder="Your email address..." />
              {errors.email.length > 0 && <span className="error">{errors.email}</span>}
            </div>
          </div>
        </div>
        {fields.accountType === 'sugar_parent' && <div className={`field-container text ${(fields.email.length > 0)?'open':'closed'}`}>
          <div className="field-title">Promocode:</div>
          <div className="row">
            <div className="col">
              <input onBlur={e => {this.handleRefCodeBlur(e)}} onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="refCode" placeholder="Your Promocode..." defaultValue={fields.refCode} />
              {errors.refCode.length > 0 && <span className="error">{errors.refCode}</span>}
            </div>
          </div>
        </div>}
        <div className="row button-container space-between">
          <button
            className="btn btn-primary"
            disabled={!this.allFieldsFilled()}
            onClick={(e) => this.handleNext(e)}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

export default Step1;


// WEBPACK FOOTER //
// ./src/components/Step1.js